// extracted by mini-css-extract-plugin
export var body = "_kr-5";
export var closeButton = "_kr-f";
export var container = "_kr-1";
export var content = "_kr-2";
export var cta = "_kr-c";
export var ctaLabel = "_kr-b";
export var eyebrow = "_kr-3";
export var howTo = "_kr-6";
export var image = "_kr-e";
export var modal = "_kr-0";
export var socialButton = "_kr-d";
export var stepCard = "_kr-8";
export var stepLabel = "_kr-a";
export var stepNumber = "_kr-9";
export var steps = "_kr-7";
export var title = "_kr-4";